export enum PatientNoteType {
    NotSpecified = 0,
    Manual = 1,
    AI = 2,
    Transcript = 3,
    SOAP = 4,
    NotesTranscript = 5,
    Image = 6,
    System = 7,
    PDF = 8,
}
